export default {
  default: 'default', //默认
  hide: 'hide', //数据隐藏
  hover: 'hover', //次激活模式，类似css中的hover
  active: 'active', //激活模式，如选中等场景
  disabled: 'disabled', //禁用模式
  mixed: 'mixed' //混合模式,比如一个row或者col里面有多种状态
}
